var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202,
    height: 38,
    viewBox: "0 0 202 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-apploye-logo-sidebar-1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apploye-logo-sidebar-1",
    clipPath: "url(#clip-apploye-logo-sidebar-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36028",
    "data-name": "Rectangle 36028",
    width: 1863,
    height: 512,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33893",
    "data-name": "Group 33893",
    transform: "translate(-26.136 -87.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_V3",
    transform: "translate(33.809 86.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6200",
    "data-name": "Group 6200",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23850",
    "data-name": "Rectangle 23850",
    width: 188.462,
    height: 34.784,
    fill: "#6776cb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18205",
    "data-name": "Path 18205",
    d: "M44.651,37.248c-8.676.455-13.357-1.38-16.2-4.278C22.11,26.523,24.96,14.8,13,11.592a27.225,27.225,0,0,0-6.453-.82,15.6,15.6,0,0,1,24.79,3.16h0l.748,1.507C42.465,36.248,44.651,37.248,44.651,37.248ZM20.061,17.261a12.844,12.844,0,0,0-7.6-4.945,27.109,27.109,0,0,0-6.4-.768A15.607,15.607,0,0,0,13.6,36.422h.017c-7.287-8.525.1-21,6.458-19.131Zm2.264,4.661-.116-.055a3.767,3.767,0,0,1-.191.58,3.922,3.922,0,0,1-3.612,2.394,3.965,3.965,0,0,1-.67-.058,3.913,3.913,0,0,1-3.113-4.89c-2.319,2.783-3.9,6.232-3.235,10.282a15.01,15.01,0,0,0,3.16,6.421l.157.191h0a15.653,15.653,0,0,0,13.314-3.223h0c-2.768-2.128-5.864-9.171-5.693-11.641Z",
    transform: "translate(-1.77 -4.272)",
    fill: "#6776cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18206",
    "data-name": "Path 18206",
    d: "M237.122,14.837a7.763,7.763,0,0,1,3.044,3.029,9.032,9.032,0,0,1,1.1,4.513,9.1,9.1,0,0,1-1.1,4.528,7.711,7.711,0,0,1-3.044,3.047,8.948,8.948,0,0,1-4.4,1.073,6.8,6.8,0,0,1-5.4-2.273v8.174H223.38V13.944h3.754v2.209a6.087,6.087,0,0,1,2.415-1.8,8.145,8.145,0,0,1,3.171-.6A8.986,8.986,0,0,1,237.122,14.837ZM235.858,26.2a5.256,5.256,0,0,0,1.406-3.818,5.261,5.261,0,0,0-1.406-3.818,4.768,4.768,0,0,0-3.583-1.449,5.09,5.09,0,0,0-2.554.646,4.679,4.679,0,0,0-1.8,1.846,5.661,5.661,0,0,0-.655,2.774,5.662,5.662,0,0,0,.664,2.777,4.678,4.678,0,0,0,1.8,1.846,5.061,5.061,0,0,0,2.554.646A4.768,4.768,0,0,0,235.87,26.2Zm22.9-11.36a7.751,7.751,0,0,1,3.047,3.029,9.033,9.033,0,0,1,1.116,4.513,9.1,9.1,0,0,1-1.1,4.528,7.7,7.7,0,0,1-3.047,3.047,8.928,8.928,0,0,1-4.4,1.073,6.8,6.8,0,0,1-5.4-2.273v8.174h-3.936V13.944H248.8v2.209a6.088,6.088,0,0,1,2.415-1.8,8.145,8.145,0,0,1,3.171-.6,8.96,8.96,0,0,1,4.389,1.084ZM257.5,26.2a5.256,5.256,0,0,0,1.406-3.818,5.261,5.261,0,0,0-1.406-3.818,4.768,4.768,0,0,0-3.583-1.449,5.09,5.09,0,0,0-2.554.646,4.658,4.658,0,0,0-1.774,1.844,5.66,5.66,0,0,0-.664,2.777,5.66,5.66,0,0,0,.664,2.777,4.658,4.658,0,0,0,1.8,1.846,5.061,5.061,0,0,0,2.548.646,4.768,4.768,0,0,0,3.583-1.452ZM266.689,7.39h3.942V30.806h-3.942Zm12.085,22.532a8.058,8.058,0,0,1-3.2-3.076,8.7,8.7,0,0,1-1.159-4.467,8.607,8.607,0,0,1,1.159-4.45,8.081,8.081,0,0,1,3.2-3.061,10.224,10.224,0,0,1,9.244,0,8.064,8.064,0,0,1,3.2,3.061,8.606,8.606,0,0,1,1.16,4.45,8.7,8.7,0,0,1-1.16,4.467,8.041,8.041,0,0,1-3.2,3.076,10.224,10.224,0,0,1-9.244,0ZM286.98,26.2a5.22,5.22,0,0,0,1.42-3.818,5.22,5.22,0,0,0-1.42-3.818,4.815,4.815,0,0,0-3.6-1.449,4.757,4.757,0,0,0-3.58,1.449,5.25,5.25,0,0,0-1.406,3.818A5.256,5.256,0,0,0,279.8,26.2a4.757,4.757,0,0,0,3.58,1.449A4.815,4.815,0,0,0,286.98,26.2Zm24.482-12.253-7.89,18.218a8.49,8.49,0,0,1-2.681,3.867,6.438,6.438,0,0,1-3.818,1.119,7.778,7.778,0,0,1-2.493-.412,5.525,5.525,0,0,1-2.029-1.133l1.577-2.9a4.348,4.348,0,0,0,1.342.852,4.078,4.078,0,0,0,1.562.316,2.687,2.687,0,0,0,1.719-.536,4.731,4.731,0,0,0,1.246-1.8l.29-.661L292.94,13.944h4.1l5.3,12.464,5.334-12.464Zm17.766,9.687H316.008a4.56,4.56,0,0,0,1.815,2.948,5.928,5.928,0,0,0,3.652,1.1,6.142,6.142,0,0,0,4.577-1.829l2.113,2.429a7.1,7.1,0,0,1-2.873,2.049,11.369,11.369,0,0,1-8.8-.409,7.971,7.971,0,0,1-3.275-3.076,8.7,8.7,0,0,1-1.159-4.467,8.826,8.826,0,0,1,1.119-4.432,7.94,7.94,0,0,1,3.11-3.078,9.062,9.062,0,0,1,4.479-1.1,8.818,8.818,0,0,1,4.4,1.09,7.676,7.676,0,0,1,3.038,3.061,9.259,9.259,0,0,1,1.1,4.56c0,.272-.032.661-.073,1.168ZM317.567,18.04a4.713,4.713,0,0,0-1.6,2.983h9.566a4.638,4.638,0,0,0-1.545-2.965,4.71,4.71,0,0,0-3.22-1.136,4.774,4.774,0,0,0-3.2,1.119ZM216.591,19.707l3.739,11.032h-4.658l-.87-2.519a8.592,8.592,0,0,1-6.722,3.035,8.35,8.35,0,0,1-8.458-8.615,8.574,8.574,0,0,1,1.7-4.954,9.227,9.227,0,0,1,7.247-3.693,8.285,8.285,0,0,1,4.954,1.565A8.189,8.189,0,0,1,216.591,19.707Zm-5.3,5.98a4.2,4.2,0,0,0,1.354-3.029,3.968,3.968,0,0,0-1.759-3.531,4.247,4.247,0,0,0-2.455-.745,4.125,4.125,0,0,0-3.562,1.815,4.348,4.348,0,0,0-.849,2.461,3.884,3.884,0,0,0,1.759,3.5,4.058,4.058,0,0,0,2.423.78,4.31,4.31,0,0,0,3.09-1.246",
    transform: "translate(-146.494 -5.248)",
    fill: "#6776cb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33825",
    "data-name": "Group 33825",
    transform: "translate(32 106.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_35998",
    "data-name": "Rectangle 35998",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#b48963",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.125,
    height: 18.125,
    rx: 9.062,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.125,
    height: 17.125,
    rx: 8.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33790",
    "data-name": "Group 33790",
    transform: "translate(1.748 1.685)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_33741",
    "data-name": "Group 33741",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33756",
    "data-name": "Rectangle 33756",
    width: 2.601,
    height: 2.601,
    transform: "translate(5.802 6.403)",
    fill: "#434343"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29204",
    "data-name": "Group 29204"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11001",
    "data-name": "Ellipse 11001",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(10.604 5.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11002",
    "data-name": "Ellipse 11002",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(9.404 3.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11003",
    "data-name": "Ellipse 11003",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(11.205 4.002)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11004",
    "data-name": "Ellipse 11004",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(12.605 5.402)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11005",
    "data-name": "Ellipse 11005",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(12.205 7.003)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11006",
    "data-name": "Ellipse 11006",
    cx: 0.3,
    cy: 0.3,
    r: 0.3,
    transform: "translate(13.806 6.403)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11020",
    "data-name": "Ellipse 11020",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(2.801 1.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11021",
    "data-name": "Ellipse 11021",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.601 2.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11012",
    "data-name": "Ellipse 11012",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(10.504 1)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11013",
    "data-name": "Ellipse 11013",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(9.004 0.4)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11014",
    "data-name": "Ellipse 11014",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(7.603 1)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11015",
    "data-name": "Ellipse 11015",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(6.603)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11016",
    "data-name": "Ellipse 11016",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(5.002 0.4)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11017",
    "data-name": "Ellipse 11017",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(4.202 1.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11018",
    "data-name": "Ellipse 11018",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(5.802 1.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11019",
    "data-name": "Ellipse 11019",
    cx: 0.7,
    cy: 0.7,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(7.403 2.601)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11022",
    "data-name": "Ellipse 11022",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(3.001 4.602)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11023",
    "data-name": "Ellipse 11023",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(2.401 6.803)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11024",
    "data-name": "Ellipse 11024",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(1.401 5.402)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11025",
    "data-name": "Ellipse 11025",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(0.6 7.203)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11026",
    "data-name": "Ellipse 11026",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(0 8.604)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11027",
    "data-name": "Ellipse 11027",
    cx: 0.3,
    cy: 0.3,
    r: 0.3,
    transform: "translate(0.6 10.004)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11031",
    "data-name": "Ellipse 11031",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(1.801 12.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11033",
    "data-name": "Ellipse 11033",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(3.201 11.205)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11037",
    "data-name": "Ellipse 11037",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(4.402 12.605)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11032",
    "data-name": "Ellipse 11032",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(3.201 13.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11043",
    "data-name": "Ellipse 11043",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(10.604 13.005)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11044",
    "data-name": "Ellipse 11044",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(10.805 11.405)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11046",
    "data-name": "Ellipse 11046",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(11.405 10.004)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11047",
    "data-name": "Ellipse 11047",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(12.205 11.605)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11038",
    "data-name": "Ellipse 11038",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(5.402 13.806)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11039",
    "data-name": "Ellipse 11039",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(6.803 14.006)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11030",
    "data-name": "Ellipse 11030",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.801 10.404)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11028",
    "data-name": "Ellipse 11028",
    cx: 0.5,
    cy: 0.5,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(1.601 8.604)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11029",
    "data-name": "Ellipse 11029",
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    transform: "translate(3.201 9.204)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11034",
    "data-name": "Ellipse 11034",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(5.002 10.805)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11035",
    "data-name": "Ellipse 11035",
    cx: 0.7,
    cy: 0.7,
    rx: 0.7,
    ry: 0.7,
    transform: "translate(7.403 11.005)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11036",
    "data-name": "Ellipse 11036",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(6.003 12.405)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11040",
    "data-name": "Ellipse 11040",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(7.803 13.005)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11041",
    "data-name": "Ellipse 11041",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(9.204 13.606)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11042",
    "data-name": "Ellipse 11042",
    cx: 0.6,
    cy: 0.6,
    r: 0.6,
    transform: "translate(9.204 11.805)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11008",
    "data-name": "Ellipse 11008",
    cx: 0.4,
    cy: 0.4,
    rx: 0.4,
    ry: 0.4,
    transform: "translate(13.206 4.002)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11009",
    "data-name": "Ellipse 11009",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(12.205 2.601)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11010",
    "data-name": "Ellipse 11010",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(10.604 2.401)",
    fill: "#b48963"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11011",
    "data-name": "Ellipse 11011",
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(9.004 1.801)",
    fill: "#b48963",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11007",
    "data-name": "Ellipse 11007",
    cx: 0.4,
    cy: 0.4,
    r: 0.4,
    transform: "translate(13.806 8.003)",
    fill: "#b48963",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11949",
    "data-name": "Ellipse 11949",
    cx: 0.6,
    cy: 0.6,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(9.553 10.004)",
    fill: "#b48963"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c5f8a6bbd6494fc9938ea5e6b63d06d1.svg";
export { ForwardRef as ReactComponent };